import { memo } from "react";
import { useHubspotChat } from "./useHubspotChat";
import Script from "next/script";

const HubspotScript = memo(function HubspotScript({ HUBSPOT_CHAT_KEY }) {
  return (
    <Script
      src={`//js.hs-scripts.com/${HUBSPOT_CHAT_KEY}.js`}
      async
      strategy="lazyOnload"
    />
  );
});

export const HubspotChat = () => {
  const HUBSPOT_CHAT_KEY = "143716894";
  useHubspotChat(HUBSPOT_CHAT_KEY);

  return <HubspotScript HUBSPOT_CHAT_KEY={HUBSPOT_CHAT_KEY} />;
};
